export const splitChargeCard = (card) => card.split(' ****');

export const addPrices = (prices) => {
  const total =  prices.reduce((sum, price) => sum + toCents(price), 0);

  return (total / 100).toFixed(2);
}

export const toCents = (amount) => {
  if (!amount) { return 0; }

  amount = amount.toString();
  let [dollars, cents] = amount.split('.');
  cents = cents ? cents.substr(0, 2) : 0;

  if (parseFloat(amount) < 0 && parseInt(dollars) === 0) {
    return -parseInt(cents);
  }

  return (parseInt(dollars || 0) * 100) + parseInt(cents);
}

export const formatPrice = (price) => {
  if (price.includes('-')) {
    price = [price.slice(0, 1), '$', price.slice(1)].join('');
  }
  else {
    price = '$' + price;
  }
  return price;
}
